export const WEBSOURCEID = '777016';
export const SOURCESYSTEMCODE = 'Email_Sign_Up';
export const CLIENTID = '6f29a511-e0ee-4e08-a164-02271df176a9';
export const CLIENTTOKEN = '78g5P5TN';